import { createContext, useContext } from "react"

import { WPGlobalFields } from "@/lib/models/common"

export const GlobalFieldsContext = createContext<WPGlobalFields["acfGlobalFields"]["acfGlobal"]>(
  null!
)
export const useGlobalFields = () => useContext(GlobalFieldsContext)
